import React, { CSSProperties, memo, useMemo } from 'react';

import { SkinSize } from '../../lib/skin/getSizeSkin/generated/types';
import { TestProps } from '../../internal/types/testTypes';
import { LoadingIndicatorProps } from '../../internal/types/loadingIndicatorTypes';
import { cn } from '../../lib/css/className/className';
import { getSizeSkin } from '../../lib/skin/getSizeSkin/getSizeSkin';
import { useVStack } from '../../hooks/useStack';

import './TextStubWithSkin.css';

const cls = cn('TextStubWithSkin');

export type StubWidth = CSSProperties['width'];

export interface TextStubWithSkinProps extends TestProps, LoadingIndicatorProps {
    /**
     * Размер скина
     */
    skinSize: SkinSize;

    /**
     * Высота элемента
     */
    height: 'current-main' | 'current-body' | 'current-caption';

    /**
     * Ширина элемента
     * @default 'auto'
     */
    width?: StubWidth;

    /**
     * Названия классов для элемента.
     */
    className?: string;
}

export const TextStubWithSkin = memo<TextStubWithSkinProps>(function Stub({
    className,
    skinSize,
    width = 'auto',
    height,
    isLoadingIndicator = true,
    ...props
}) {
    const sizeSkinClass = getSizeSkin(skinSize);

    const stackClasses = useVStack({
        justifyContent: 'center',
    });

    const style = useMemo<CSSProperties>(() => ({ width }), [width]);
    return (
        <span className={cls('container', { height }, [stackClasses, sizeSkinClass, className])} style={style}>
            <span
                className={cls({ height })}
                data-testid={props['data-testid']}
                data-loading-indicator={isLoadingIndicator || undefined}
            />
        </span>
    );
});
